import { LoadingSvg } from "../icons/Icon";

export const Loading = () => {
    return(
        <div className="loader"><LoadingSvg /></div>
    );
};